import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';

const path = 'my/feed/customize';

const FeedCustomizationRoute = (
  <Route
    key={path}
    path={path}
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'feed' */
        '../components/discovery/feed/customization'
      )).default,
    })}
  />
);

export default FeedCustomizationRoute;
